interface Segment {
  label: string
  value: number
  color: string
}

interface ProgressBarProps {
  segments: Segment[]
  total: number
}

function ProgressBar({ segments, total }: ProgressBarProps) {
  const safeTotal = total > 0 ? total : 1
  return (
    <div>
      <div className="flex h-3 w-full overflow-hidden rounded-full bg-slate-800">
        {segments.map((segment) => {
          const width = Math.max(0, Math.min(100, (segment.value / safeTotal) * 100))
          return <div key={segment.label} className={segment.color} style={{ width: `${width}%` }} />
        })}
      </div>
      <div className="mt-3 flex flex-wrap gap-4">
        {segments.map((segment) => (
          <div key={segment.label} className="flex items-center gap-2 text-xs text-slate-400">
            <span className={`h-2 w-2 rounded-full ${segment.color}`} />
            <span>{segment.label}</span>
            <span className="font-mono text-slate-300">{((segment.value / safeTotal) * 100).toFixed(1)}%</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProgressBar
